import { render, staticRenderFns } from "./call.vue?vue&type=template&id=39757102"
import script from "./call.vue?vue&type=script&lang=js"
export * from "./call.vue?vue&type=script&lang=js"
import style0 from "./call.vue?vue&type=style&index=0&id=39757102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports